<template>
  <div class="cadrePhoto">
    <router-link :to="to"><img :idPicture="prf.mainPicture.id" :src="prf.mainPicture.name" class="photo"/></router-link>
    <div class="dernierPseudo">
      <span class="pinklive">{{ prf.pseudo }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhotoAccueil",
  props: {
    prf: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    to() {
      return {
        name: "Profil",
        query: {
          p: this.prf.pseudo
        }
      };
    }
  }
};
</script>

<style scoped>
.dernierPseudo {
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
  background-color: white;
}
</style>
